export type ConfigurationSortKey = 'lowestPrice' | 'priceAdd';

export function sortConfigurationResults<
  T extends { lowestPrice: number; priceAdd?: number }
>(results: T[], sortKey: ConfigurationSortKey = 'lowestPrice'): T[] {
  const price = (x: T): number => {
    const raw =
      sortKey === 'priceAdd' && typeof x.priceAdd === 'number'
        ? x.priceAdd
        : x.lowestPrice;

    return isFinite(raw) ? raw : 0;
  };

  return [...results].sort((a, b) => price(a) - price(b));
}
